'use strict';
var React = require('react');
var _ = require('underscore');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var appTypes = require('../../types/appTypes');
var CheckIcon = require('./CheckIcon');
var propsConst = require('../../constants/propConst');

/**
 * CheckBoxItem
 * @author mxj
 * @createDate 2016-8-3
 **/

var CheckBoxItem = React.createClass({

  _doPaint() {
    var selfDom = ReactDOM.findDOMNode(this);
    var parentDom;
    var measureSize;

    parentDom = selfDom.parentElement;
    while (!parentDom && (parentDom.id !== this.props.controlID)) {
      parentDom = parentDom.parentElement;
    }

    if (parentDom) {
      measureSize = AutoSizeHelper.getComAutoSize(this.props);
      parentDom.style.width = (measureSize.width + 20) + 'px';
    }
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.text !== this.props.text) {
      this.isInvalid = true;
    }
  },

  componentDidUpdate: function () {
    this._doPaint();
  },

  componentDidMount: function () {
    this.canFocus = false;
    this._doPaint();
  },

  getInitialState: function () {
    return {
      checked: this.props.isChecked
    };
  },

  render: function () {
    this.isLeftText = this.props.textDirection === appTypes.TextDirection.LEFT;
    var divStyle;
    var textStyle;

    var size = styleHelper.getInt(this.props,propsConst.SIZE)||16;
    var gap = styleHelper.getInt(this.props,propsConst.GAP) || 0;
    divStyle = {
      width: '100%',
      height: '100%',
      opacity : this.props.isDisabled ? 0.6:1,
      //overflow:'hidden',
      pointerEvents : this.props.isDisabled ? 'none':'auto'
    };


    textStyle = {
      left : this.props.textDirection === appTypes.TextDirection.LEFT ? 0 : (size + gap),
      top : 0,
      height : styleHelper.getHeight(this.props),
      width : styleHelper.getWidth(this.props) - size - gap,
      lineHeight: styleHelper.getHeight(this.props) + 'px',
      position : 'absolute',
      textDecoration : 'inherit',
      whiteSpace:'nowrap',
      overflow: 'hidden'
    };
    styleHelper.StyleUtil(this.props).default(divStyle).text().align();
    return (
      <div style={divStyle} onClick={this._onClick}>
        <CheckIcon {...{
          enabled:_.isUndefined(this.props.enabled)?true:this.props.enabled,
          size: size,
          color: this.props.borderColor,
          left: this.props.textDirection === appTypes.TextDirection.RIGHT ? 0 : (styleHelper.getWidth(this.props) - size),
          top: (styleHelper.getHeight(this.props) - size) / 2,
          isChecked: this.canFocus ?this.state.checked : this.props.isChecked,
          borderColor: styleHelper.getBorderColor(this.props)
        }}/>
        <div style={textStyle}>
          <label>{styleHelper.getText(this.props)}</label>
        </div>
      </div>
    );
  },

  _onClick: function (e) {
    var arg = arguments;
    var index = 0;
    e.stopPropagation();
    this.canFocus = true;
    this.setState({
      checked: !this.state.checked
    });

    if(this.props.onChecked){
      if(!_.isUndefined(this.props.index)){
        index = this.props.index;
      }
      this.props.onChecked(index,this.state.checked);
    }
  }
});

module.exports = CheckBoxItem;


// WEBPACK FOOTER //
// ./src/views/common/CheckBoxItem.jsx